import { LoadingComments } from '../LoadingComments';

export default function LoadingTdmDetail() {
  return (
    <div className='flex gap-4 w-full mt-6'>
      <div className='w-full'>
        <section className='h-80 animate-pulse bg-neutralColor-light rounded-md p-4'>
          <div className='flex justify-between w-full'>
            <div className='w-1/2'>
              <div className='h-5 bg-neutralColor-light rounded-md'></div>
              <div className='h-5 bg-neutralColor-light rounded-md w-24 mt-2'></div>
            </div>
            <div className='h-10 bg-neutralColor-light rounded-md w-24'></div>
          </div>
          <div className='mt-4 border-t border-gray-200 px-4 py-5 sm:px-6'>
            <dl className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2'>
              <div className='sm:col-span-1'>
                <dt className='w-24 bg-neutralColor-light h-2 rounded-md'></dt>
                <dd className='mt-2 w-36 bg-neutralColor-light h-2 rounded-md'></dd>
              </div>
              <div className='sm:col-span-1'>
                <dd className='mt-1 flex items-center gap-2'>
                  <span className='h-10 w-10 rounded-full bg-neutralColor-light'></span>
                  <span className='h-5 bg-neutralColor-light w-24 rounded-md'></span>
                </dd>
              </div>
              <div className='sm:col-span-1'>
                <dd className='flex items-center gap-2'>
                  <span className='h-10 w-10 rounded-full bg-neutralColor-light'></span>
                  <span className='h-5 bg-neutralColor-light w-24 rounded-md'></span>
                </dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='w-24 bg-neutralColor-light h-2 rounded-md'></dt>
                <dd className='mt-2 w-36 bg-neutralColor-light h-2 rounded-md'></dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='w-24 bg-neutralColor-light h-2 rounded-md'></dt>
                <dd className='mt-2 w-36 bg-neutralColor-light h-2 rounded-md'></dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='w-24 bg-neutralColor-light h-2 rounded-md'></dt>
                <dd className='mt-2 w-36 bg-neutralColor-light h-2 rounded-md'></dd>
              </div>
            </dl>
          </div>
        </section>
        <section className='h-80 animate-pulse bg-neutralColor-light rounded-md p-4 mt-6'>
          <div className='w-24 h-6 bg-neutralColor-light rounded-md'></div>
          <LoadingComments />
        </section>
      </div>
      <div className='w-1/2'>
        <section className='h-80 animate-pulse bg-neutralColor-light rounded-md p-4'>
          <div className='w-24 h-6 bg-neutralColor-light rounded-md'></div>
          <div className='mt-4 border-t border-gray-200 w-full'></div>
          <div className='mt-4 flex gap-4 w-full justify-between'>
            <div className='w-full h-10 bg-neutralColor-light rounded-md'></div>
            <div className='w-10 h-10 bg-neutralColor-light rounded-md'></div>
          </div>
          <div className='mt-6 w-24 h-2 bg-neutralColor-light rounded-md'></div>
          <div className='mt-2 flex gap-4 w-full justify-between'>
            <div className='w-full h-10 bg-neutralColor-light rounded-md'></div>
            <div className='w-10 h-10 bg-neutralColor-light rounded-md'></div>
          </div>
        </section>
      </div>
    </div>
  );
}
